const mapAdminApiError = (error) => {
  const status = error?.response?.status;
  const backendMessage = error?.response?.data?.message || error?.response?.data?.detail || '';
  const rawMessage = String(backendMessage || error?.message || '').trim();

  const normalized = rawMessage.toLowerCase();

  if (normalized.includes('token has expired') || normalized.includes('refresh failed') || normalized.includes('sso')) {
    return {
      title: 'Sessao AWS SSO expirada no backend',
      description: 'Renove o SSO no servidor: aws sso login --profile techdash-dev --use-device-code',
    };
  }

  if (normalized.includes('aws credentials not configured')) {
    return {
      title: 'Credencial AWS nao configurada no backend',
      description: 'Configure AWS_PROFILE/credenciais no runtime do backend para o painel admin operar.',
    };
  }

  if (status === 403) {
    return {
      title: 'Acesso negado',
      description: 'Seu usuario nao possui permissao de administrador para este painel.',
    };
  }

  return {
    title: 'Falha operacional no painel admin',
    description: rawMessage || 'Erro nao mapeado na chamada de administracao.',
  };
};

export { mapAdminApiError };
